import {Pipe, PipeTransform} from '@angular/core';
import {TriggerEvents} from '../../models/trigger-events';

@Pipe({
  name: 'allowsChannel'
})
export class AllowsChannelPipe implements PipeTransform {
  transform(event: string): boolean {
    return TriggerEvents.allowsChannel(event);
  }
}
